import * as React from 'react';

function DevicesIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M7 11V7a5 5 0 1110 0v4M5 11h14a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default DevicesIcon;
